import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-expandable-text',
  templateUrl: './expandable-text.component.html',
  styleUrls: ['./expandable-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ExpandableTextComponent implements OnDestroy, AfterViewInit {
  @Input() text = ''; // Provide a default value to avoid undefined
  @Input() trim = false; // Provide a default value

  @ViewChild('textContent') textElement!: ElementRef<HTMLElement>; // Use non-null assertion operator

  showExpand = true;
  expanded = false;

  MAX_HEIGHT = 80;

  private subscriptions: Subscription = new Subscription(); // Initialize as a Subscription

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: object,
    private readonly cd: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.checkForChanges();
    // Ensure that interval only runs in the browser
    if (isPlatformBrowser(this.platformId)) {
      this.subscriptions.add(
        interval(250).subscribe(() => this.checkForChanges())
      );
    }
  }

  expand(): void {
    this.expanded = true;
    this.cd.markForCheck();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe(); // Unsubscribe from all subscriptions
  }

  private checkForChanges(): void {
    const height = this.textElement?.nativeElement.clientHeight || 0; // Use optional chaining and default value
    const highEnough = height >= this.MAX_HEIGHT;
    const oldExpand = this.showExpand;

    this.showExpand = !this.expanded && this.trim && highEnough;

    // Only detect changes if there is a change in the `showExpand` value
    if (oldExpand !== this.showExpand) {
      this.cd.detectChanges();
    }
  }
}
